import { dateLocale } from '../i18n/i18n'

export const getAllCountries = () => {
    return [
        'Afghanistan',
        'Åland Islands',
        'Albania',
        'Algeria',
        'American Samoa',
        'Andorra',
        'Angola',
        'Anguilla',
        'Antarctica',
        'Antigua and Barbuda',
        'Argentina',
        'Armenia',
        'Aruba',
        'Australia',
        'Austria',
        'Azerbaijan',
        'Bahamas',
        'Bahrain',
        'Bangladesh',
        'Barbados',
        'Belarus',
        'Belgium',
        'Belize',
        'Benin',
        'Bermuda',
        'Bhutan',
        'Bolivia (Plurinational State of)',
        'Bonaire, Sint Eustatius and Saba',
        'Bosnia and Herzegovina',
        'Botswana',
        'Bouvet Island',
        'Brazil',
        'British Indian Ocean Territory',
        'Brunei Darussalam',
        'Bulgaria',
        'Burkina Faso',
        'Burundi',
        'Cabo Verde',
        'Cambodia',
        'Cameroon',
        'Canada',
        'Cayman Islands',
        'Central African Republic',
        'Chad',
        'Chile',
        'China',
        'Christmas Island',
        'Cocos (Keeling) Islands',
        'Colombia',
        'Comoros',
        'Congo',
        'Congo, Democratic Republic of the',
        'Cook Islands',
        'Costa Rica',
        'Côte d\'Ivoire',
        'Croatia',
        'Cuba',
        'Curaçao',
        'Cyprus',
        'Czechia',
        'Denmark',
        'Djibouti',
        'Dominica',
        'Dominican Republic',
        'Ecuador',
        'Egypt',
        'El Salvador',
        'Equatorial Guinea',
        'Eritrea',
        'Estonia',
        'Eswatini',
        'Ethiopia',
        'Falkland Islands (Malvinas)',
        'Faroe Islands',
        'Fiji',
        'Finland',
        'France',
        'French Guiana',
        'French Polynesia',
        'French Southern Territories',
        'Gabon',
        'Gambia',
        'Georgia',
        'Germany',
        'Ghana',
        'Gibraltar',
        'Greece',
        'Greenland',
        'Grenada',
        'Guadeloupe',
        'Guam',
        'Guatemala',
        'Guernsey',
        'Guinea',
        'Guinea-Bissau',
        'Guyana',
        'Haiti',
        'Heard Island and McDonald Islands',
        'Holy See',
        'Honduras',
        'Hong Kong',
        'Hungary',
        'Iceland',
        'India',
        'Indonesia',
        'Iran (Islamic Republic of)',
        'Iraq',
        'Ireland',
        'Isle of Man',
        'Israel',
        'Italy',
        'Jamaica',
        'Japan',
        'Jersey',
        'Jordan',
        'Kazakhstan',
        'Kenya',
        'Kiribati',
        'Korea (Democratic People\'s Republic of)',
        'Korea, Republic of',
        'Kuwait',
        'Kyrgyzstan',
        'Lao People\'s Democratic Republic',
        'Latvia',
        'Lebanon',
        'Lesotho',
        'Liberia',
        'Libya',
        'Liechtenstein',
        'Lithuania',
        'Luxembourg',
        'Macao',
        'Madagascar',
        'Malawi',
        'Malaysia',
        'Maldives',
        'Mali',
        'Malta',
        'Marshall Islands',
        'Martinique',
        'Mauritania',
        'Mauritius',
        'Mayotte',
        'Mexico',
        'Micronesia (Federated States of)',
        'Moldova, Republic of',
        'Monaco',
        'Mongolia',
        'Montenegro',
        'Montserrat',
        'Morocco',
        'Mozambique',
        'Myanmar',
        'Namibia',
        'Nauru',
        'Nepal',
        'Netherlands',
        'New Caledonia',
        'New Zealand',
        'Nicaragua',
        'Niger',
        'Nigeria',
        'Niue',
        'Norfolk Island',
        'North Macedonia',
        'Northern Mariana Islands',
        'Norway',
        'Oman',
        'Pakistan',
        'Palau',
        'Palestine, State of',
        'Panama',
        'Papua New Guinea',
        'Paraguay',
        'Peru',
        'Philippines',
        'Pitcairn',
        'Poland',
        'Portugal',
        'Puerto Rico',
        'Qatar',
        'Réunion',
        'Romania',
        'Russian Federation',
        'Rwanda',
        'Saint Barthélemy',
        'Saint Helena, Ascension and Tristan da Cunha',
        'Saint Kitts and Nevis',
        'Saint Lucia',
        'Saint Martin (French part)',
        'Saint Pierre and Miquelon',
        'Saint Vincent and the Grenadines',
        'Samoa',
        'San Marino',
        'Sao Tome and Principe',
        'Saudi Arabia',
        'Senegal',
        'Serbia',
        'Seychelles',
        'Sierra Leone',
        'Singapore',
        'Sint Maarten (Dutch part)',
        'Slovakia',
        'Slovenia',
        'Solomon Islands',
        'Somalia',
        'South Africa',
        'South Georgia and the South Sandwich Islands',
        'South Sudan',
        'Spain',
        'Sri Lanka',
        'Sudan',
        'Suriname',
        'Svalbard and Jan Mayen',
        'Sweden',
        'Switzerland',
        'Syrian Arab Republic',
        'Taiwan, Province of China',
        'Tajikistan',
        'Tanzania, United Republic of',
        'Thailand',
        'Timor-Leste',
        'Togo',
        'Tokelau',
        'Tonga',
        'Trinidad and Tobago',
        'Tunisia',
        'Turkey',
        'Turkmenistan',
        'Turks and Caicos Islands',
        'Tuvalu',
        'Uganda',
        'Ukraine',
        'United Arab Emirates',
        'United Kingdom of Great Britain and Northern Ireland',
        'United States of America',
        'United States Minor Outlying Islands',
        'Uruguay',
        'Uzbekistan',
        'Vanuatu',
        'Venezuela (Bolivarian Republic of)',
        'Viet Nam',
        'Virgin Islands (British)',
        'Virgin Islands (U.S.)',
        'Wallis and Futuna',
        'Western Sahara',
        'Yemen',
        'Zambia',
        'Zimbabwe',
    ]
}

// Official ISO names in the list above that the browser's English region
// names spell differently ("Viet Nam" vs "Vietnam").
const OFFICIAL_NAME_CODES = {
    'Bolivia (Plurinational State of)': 'BO', 'Bonaire, Sint Eustatius and Saba': 'BQ', 'Brunei Darussalam': 'BN',
    'Cabo Verde': 'CV', 'Congo': 'CG', 'Congo, Democratic Republic of the': 'CD', 'Falkland Islands (Malvinas)': 'FK',
    'Holy See': 'VA', 'Hong Kong': 'HK', 'Iran (Islamic Republic of)': 'IR', "Korea (Democratic People's Republic of)": 'KP',
    'Korea, Republic of': 'KR', "Lao People's Democratic Republic": 'LA', 'Macao': 'MO', 'Micronesia (Federated States of)': 'FM',
    'Moldova, Republic of': 'MD', 'Myanmar': 'MM', 'Palestine, State of': 'PS', 'Pitcairn': 'PN', 'Russian Federation': 'RU',
    'Saint Barthélemy': 'BL', 'Saint Helena, Ascension and Tristan da Cunha': 'SH', 'Saint Kitts and Nevis': 'KN',
    'Saint Lucia': 'LC', 'Saint Martin (French part)': 'MF', 'Saint Pierre and Miquelon': 'PM',
    'Saint Vincent and the Grenadines': 'VC', 'Sao Tome and Principe': 'ST', 'Sint Maarten (Dutch part)': 'SX',
    'Syrian Arab Republic': 'SY', 'Taiwan, Province of China': 'TW', 'Tanzania, United Republic of': 'TZ', 'Turkey': 'TR',
    'United Kingdom of Great Britain and Northern Ireland': 'GB', 'United States of America': 'US',
    'United States Minor Outlying Islands': 'UM', 'Venezuela (Bolivarian Republic of)': 'VE', 'Viet Nam': 'VN',
    'Virgin Islands (British)': 'VG', 'Virgin Islands (U.S.)': 'VI',
}

const normalize = (name) => name.toLowerCase().replace(/&/g, 'and').replace(/[’‘]/g, "'")

let codeByName
const regionCode = (name) => {
    if (!codeByName) {
        codeByName = new Map(Object.entries(OFFICIAL_NAME_CODES).map(([n, code]) => [normalize(n), code]))
        try {
            const english = new Intl.DisplayNames(['en'], { type: 'region' })
            for (let a = 65; a < 91; a++) for (let b = 65; b < 91; b++) {
                const code = String.fromCharCode(a, b)
                let label
                try { label = english.of(code) } catch (e) { continue }
                if (label && label !== code && !codeByName.has(normalize(label))) codeByName.set(normalize(label), code)
            }
        } catch (e) { /* Intl.DisplayNames unsupported: names stay in English. */ }
    }
    return codeByName.get(normalize(name))
}

/**
 * A country from the list above, named in the UI language. The stored value
 * stays the English name; only what the user reads changes.
 */
export const countryLabel = (name) => {
    const locale = dateLocale()
    if (!name || locale.startsWith('en')) return name
    const code = regionCode(name)
    if (!code) return name
    try {
        return new Intl.DisplayNames([locale], { type: 'region' }).of(code) || name
    } catch (e) {
        return name
    }
}
